const notificationTabs = [
	{
		label: "All",
		value: "all"
	},
	{
		label: "Creation",
		value: "creation"
	},
	{
		label: "Registration",
		value: "registration"
	},
	{
		label: "Edit",
		value: "edit"
	},
	{
		label: "Plan Creation",
		value: "plan_creation"
	},
	{
		label: "Open Enrollment",
		value: "open_enrollment"
	},
	{
		label: "Enrollment Submission",
		value: "enrollment_submission"
	},
	// {
	// 	label: "Approval",
	// 	value: "approval"
	// },
	// {
	// 	label: "Employer Chat Support",
	// 	value: "employer_chat_support"
	// },
	// {
	// 	label: "Member Chat Support",
	// 	value: "member_chat_support"
	// },
	{
		label: "Blogs",
		value: "blogs"
	},
	{
		label: "Announcements",
		value: "announcements"
	},
	{
		label: "Statement of Understanding",
		value: "statement_of_understanding"
	},
	{
		label: "Registration Help",
		value: "registration_help"
	},
	{
		label: "Termination",
		value: "terminate"
	},
	{
		label: "Reinstate",
		value: "reinstate"
	},
	{
		label: "Rehired",
		value: "rehire"
	}
];

export const NOTIFICATION_TABS = notificationTabs;
